import React, { useState, useMemo, useCallback } from "react";
import { Menu, Dropdown } from "antd";
import { menu, MenuEnum } from "./config";
import IconFont from "@/components/icon";
import "./index.less";
import { analysisLog } from "@/utils/logAnalytics";
const { SubMenu } = Menu;

interface IProps {
  onChange?: Function;
  defaultActiveKey?: MenuEnum;
  menuList?: any;
  arrow?: boolean;
  disabled?: boolean;
}

const SharesFilter = (props: IProps) => {
  const {
    onChange,
    defaultActiveKey = MenuEnum.SHARES,
    menuList = [],
    arrow = true,
    disabled = false
  } = props;
  // console.log(menuList, 'menuListmenuListmenuList', menu);
  const [defaultName, setDefaultName] = useState("");
  const [visible, setVisible] = useState(false);
  const [checkedKey, setCheckedKey] = useState(defaultActiveKey);
  // 给初始值
  useMemo(() => {
    const item: any = menu.find((item) => item.type === defaultActiveKey);
    if (item) {
      setDefaultName(item.name);
    }
  }, [defaultActiveKey]);
  const onClick = (_item: any) => {
    const { key = "", name = "", item = {} } = _item;
    onChange?.(key);
    setVisible(false);
    setDefaultName(item.node.innerHTML);
    // console.log(_item, '_item_item_item_item_item');
    setCheckedKey(key);
    const from = document.location.pathname.includes("shares") ? "SHARES" : "TEAM_SPACE";
    analysisLog("xtbg_jzb_joyspace_home_1676548210761", "33", from);
  };
  const onVisibleChange = useCallback((val) => {
    setVisible(val);
  }, []);
  const menus = () => {
    return (
      <Menu onClick={onClick}>
        {(menuList.length > 0 ? menuList : menu).map((item: any, index: any) => {
          if (item.children && !item.children.length) {
            return (
              <Menu.Item
                className={item.type === checkedKey ? "shares-filter-checked" : ""}
                key={item.type}
              >
                {item.name}
              </Menu.Item>
            );
          }
          return (
            <SubMenu key={index} title={item.name}>
              {item.children.map((_item: any) => (
                <Menu.Item key={_item.type}>{_item.name}</Menu.Item>
              ))}
            </SubMenu>
          );
        })}
      </Menu>
    );
  };
  return (
    <Dropdown
      trigger={["click"]}
      overlay={menus}
      onVisibleChange={onVisibleChange}
      overlayClassName="joyspace-share-dropdown"
      disabled={(menuList.length > 0 ? menuList : menu).length === 1 || disabled}
    >
      <span
        className={visible ? "shares-filter-menus shares-filter-checked" : "shares-filter-menus"}
        onClick={(e) => e.preventDefault()}
      >
        {defaultName}
        {(menuList.length > 0 ? menuList : menu).length > 1 && (
          <IconFont className="shares-filter-menus-icon" type="iconjs_ilist_arrowdown" />
        )}
      </span>
    </Dropdown>
  );
};

export default SharesFilter;
